import { $Elements, BrowserEvents, Classes, Elements } from '../global/constants';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Campaign ----------

		if(typeof campaign_params !== 'undefined') {

			$('form.campaign-form').each(function() {

				const form = $(this);
				const input = form.find('input[type=email]');
				const button = form.find('button[type=submit]');
				const tooltip = form.find('.invalid-tooltip');
				const formContent = form.find('.form-content');
				const formDone = form.find('.form-done');
				const success = formDone.find('.success');
				const error = formDone.find('.error');

				form.on('submit', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();

					input.removeClass('is-invalid');
					button.attr('disabled', true);
					Elements.LoadingBar.classList.add(Classes.loading);

					const formData = new FormData(form[0]);
					formData.append('action', campaign_params.action);
					formData.append('nonce', campaign_params.nonce);

					$.ajax({
						url: campaign_params.url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					}).always((response) => {

						button.attr('disabled', false);
						Elements.LoadingBar.classList.remove(Classes.loading);

						if(response.success) {
							formContent.addClass('d-none');
							formDone.removeClass('d-none');
							success.removeClass('d-none');
							success.find('.h2').text(response.data.message);
							success.find('p').addClass('d-none');
						}
						else {
							tooltip.text(response.data.error);
							input.addClass('is-invalid');
							console.error(response);
						}
					});

					return false;
				});
			});
		}
	});

}(jQuery));
